import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { JSONStringify, ParseQueryType } from 'zigra-ng-framework';
import {
    DigitalClientCardType,
    DigitalClientCardTypeQuery,
    ElectronicCashRegisterInputType,
    ElectronicCashRegisterTypeQuery,
    InvoiceType
} from '../zigra-schema.autogenerated.models';

@Injectable()
export class ElectronicCashRegisterExSchema {
    //private schemaEndPoint = 'https://localhost:7043/graphql/Authorized/Solutions';
    // protected endpoint: string = `${environment.graphQLEndPoint}/Authorized/ElectronicCashRegisterGraphQLSchema`;
    // protected entityName: string = 'ElectronicCashRegister';

    protected entityName: string = 'ElectronicCashRegister';
    protected schemaEndPoint = `${environment.graphQLEndPoint}/Authorized/ElectronicCashRegisterGraphQLSchema`;

    constructor(protected http: HttpClient) {}

    public RemoveActiveInvoiceAndUnlockLockECR(
        electronicCashRegister: ElectronicCashRegisterInputType,
        query: ElectronicCashRegisterTypeQuery
    ) {
        debugger;
        const sQuery = `mutation RemoveActiveInvoiceAndUnlockLockECR {
            RemoveActiveInvoiceAndUnlockLockECR(ElectronicCashRegister: ${JSONStringify(electronicCashRegister)}) 
             { ${ParseQueryType<DigitalClientCardTypeQuery>(query)} }  
        }`;

        return this.http.post<{
            data: {
                RemoveActiveInvoiceAndUnlockLockECR:
                    | DigitalClientCardType
                    | undefined;
            };
        }>(this.schemaEndPoint, {
            query: sQuery
        });
    }
}
